import React from "react";
import { useJob } from "@/modules/work/jobs/context";

const BillableJobsBanner = () => {

    const { billablesJobCount } = useJob();

    if (!billablesJobCount) return null;

    const message =
        billablesJobCount === 1
            ? "Approving this job extension request will affect 1 billable connected to this job. Please review it before approval."
            : `Approving this job extension request will affect ${billablesJobCount} billables connected to this job. Please review them before approval.`;

    return (
        <aside
            role="banner"
            aria-label="Job extension billables announcement"
            className="pt-6 px-6"
        >
            <div className="flex items-center bg-red-50 pl-4 pr-6 py-3 md:py-4 relative rounded-xl mx-auto">
                <span className="text-sm text-red-700">
                    <span className="font-semibold">Note</span>: {message}
                </span>
            </div>
        </aside>
    );
};

export default BillableJobsBanner;
